export default function HeaderLogin() {
    return (
        <header className="fixed top-0 left-0 right-0 bg-black shadow-lg z-50">
        <div className="container mx-auto flex justify-center items-center py-3 md:py-4">
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/cg-ses-files-upload.appspot.com/o/hostingImage%2FCRC_BK_BIG_Black.png?alt=media&token=19509bea-d71a-40a6-95bc-7fcc72c69c6e" 
            alt="Central Group Logo"
            className="h-4 md:h-6 lg:h-8 w-auto transition-transform hover:scale-105" 
          />
        </div>
      </header>
    );
}


// https://firebasestorage.googleapis.com/v0/b/cg-ses-files-upload.appspot.com/o/hostingImage%2Fcentralretail-B0.png?alt=media&token=d0c87e96-ae77-49f8-9555-c93efdfdea45